import react, { Component } from "react";
import Footer from "./footer";
import Header from "./Header";
import ContentLoader from "react-content-loader";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { PhoneNumberUtil } from "google-libphonenumber";
import countryList from "react-select-country-list";

import {
  addSettings,
  addMsaInfo,
  setLeftMenu,
  setUserPermissions,
} from "../../actions";

import LefeSideBar from "./leftSideBar";
import Dashboard from "../../Pages/Reseller/Dashboard";

import Clients from "../../Pages/Reseller/Clients";
import LoadCredit from "../../Pages/Reseller/LoadCredit";
import Clientagreements from "../../Pages/Reseller/Clients/agreements";
import AddClientagreements from "../../Pages/Reseller/Clients/addagreement";
import AddClientagreement from "../../Pages/Reseller/Clients/addclientagreement";
import EditClientagreements from "../../Pages/Reseller/Clients/editagreement";
import Subclients from "../../Pages/Reseller/Clients/subclients";
import Subclientrights from "../../Pages/Reseller/Clients/subclientrights";
import ViewClient from "../../Pages/Reseller/Clients/viewClient";

import PackageAgreements from "../../Pages/Reseller/PackageAgreements/index";
import AddPackageAgreements from "../../Pages/Reseller/PackageAgreements/addagreement";
import EditPackageAgreements from "../../Pages/Reseller/PackageAgreements/editagreement";

import CannedEmails from "../../Pages/Reseller/CannedEmails";
import Editemail from "../../Pages/Reseller/CannedEmails/editemail";
import EditAgentemail from "../../Pages/Reseller/CannedEmails/edit_agent_email";
import PreViewEmail from "../../Pages/Reseller/CannedEmails/preview";
import PreviewAgentEmail from "../../Pages/Reseller/CannedEmails/preview_agent";

import Notifications from "../../Pages/Reseller/Notifications";

import Addclient from "../../Pages/Reseller/Clients/addclient";

import SubUsers from "../../Pages/Reseller/Users";
import AddUsers from "../../Pages/Reseller/Users/adduser";
import UserRoles from "../../Pages/Reseller/Users/user_roles";

import AdminRoles from "../../Pages/Reseller/AdminRoles/index";
import EditAdminRole from "../../Pages/Reseller/AdminRoles/edit_role";
import EditAdminSubRole from "../../Pages/Reseller/AdminRoles/edit_sub_role";
import AddSubUserGroup from "../../Pages/Reseller/AdminRoles/addGroup";
import EditSubUserGroup from "../../Pages/Reseller/AdminRoles/editGroup";

import AgentPermissons from "../../Pages/Reseller/AgentPermissons";

import ClientRoles from "../../Pages/Reseller/ClientRoles";
import AddClientRole from "../../Pages/Reseller/ClientRoles/AddClientRole";
import AddClientSubRole from "../../Pages/Reseller/ClientRoles/AddClientSubRole";
import EditClientRole from "../../Pages/Reseller/ClientRoles/editClientRole";
import EditClientSubRole from "../../Pages/Reseller/ClientRoles/editClientSubRole";
import ClientRoleAddGroup from "../../Pages/Reseller/ClientRoles/addGroup";
import ClientRoleEditGroup from "../../Pages/Reseller/ClientRoles/editGroup";
import Addsubclient from "../../Pages/Reseller/Clients/addsubclient";

import Services from "../../Pages/Reseller/Services";

import Productagreements from "../../Pages/Reseller/Services/agreements";
import AddProductagreements from "../../Pages/Reseller/Services/addagreement";
import EditProductagreements from "../../Pages/Reseller/Services/editagreement";

import Addservice from "../../Pages/Reseller/Services/addservice";
import Editservice from "../../Pages/Reseller/Services/editservice";
import Addratedeck from "../../Pages/Reseller/Services/addratedeck";
import Addbundle from "../../Pages/Reseller/Services/addbundle";

import ServiceType from "../../Pages/Reseller/Services/servicetype";
import EditServiceType from "../../Pages/Reseller/Services/editservicetype";
import AddServiceType from "../../Pages/Reseller/Services/addServiceType";

import Analytics from "../../Pages/Reseller/Analytics";
import Reports from "../../Pages/Reseller/Reports";
import EmailNotifications from "../../Pages/Reseller/Email_notifications";
import Agreements from "../../Pages/Reseller/Agreements";
import Pdfdownload from "../../Pages/Reseller/Agreements/pdfdownload";

import Subagents from "../../Pages/Reseller/Agents/subagent";
import ViewAgentArchivedSubmission from "../../Pages/Reseller/Forms/view_agent_archived_submission";
import ViewSupplierArchivedSubmission from "../../Pages/Reseller/Forms/view_supplier_archived_submission";

import Agents from "../../Pages/Reseller/Agents";
import Addagent from "../../Pages/Reseller/Agents/addagent";
import AgentCommissions from "../../Pages/Reseller/Agents/commissions";

import ViewAgent from "../../Pages/Reseller/Agents/viewAgent";
import Addsubagent from "../../Pages/Reseller/Agents/addsubagent";
import PartnerSubagents from "../../Pages/Reseller/Agents/partner_subagent";
import Addpartnersubagent from "../../Pages/Reseller/Agents/addpartnersubagent";

import Agentagreements from "../../Pages/Reseller/Agents/agreements";
import AddAgentagreements from "../../Pages/Reseller/Agents/addagreement";

// SIP Trunk Imports
import AllTrunks from "../../Pages/Reseller/Trunk";
import PendingApproval from "../../Pages/Reseller/Trunk/pendingApproval";
import AddTrunk from "../../Pages/Reseller/Trunk/addTrunk";

// Remediation Imports
// import BatchManagement from "../../Pages/Reseller/Remediation/BatchManagement";
// import BatchView from "../../Pages/Reseller/Remediation/BatchView";
// import NumberRegistry from "../../Pages/Reseller/Remediation/NumberRegistry";
// import ANIMonitoring from "../../Pages/Reseller/Remediation/ANIMonitoring";
// import OPERATIONS from "../../Pages/Reseller/Remediation/Operations";
import EditAgentagreements from "../../Pages/Reseller/Agents/editagreement";

import Supplieragreements from "../../Pages/Reseller/Suppliers/agreements";
import AddSupplieragreements from "../../Pages/Reseller/Suppliers/addagreement";
import EditSupplieragreements from "../../Pages/Reseller/Suppliers/editagreement";

import Suppliers from "../../Pages/Reseller/Suppliers";
import AddSupplier from "../../Pages/Reseller/Suppliers/addSupplier";
import ViewSupplier from "../../Pages/Reseller/Suppliers/viewSupplier";

import Upgrades from "../../Pages/Reseller/Upgrades";
import BackOffice from "../../Pages/Reseller/BackOffice";
import MSA from "../../Pages/Reseller/MSA";
import Integrations from "../../Pages/Reseller/Integrations";

import ApiDetails from "../../Pages/Reseller/Upgrades/apiDetails";
import MetaBaseSettings from "../../Pages/Reseller/Upgrades/metaBaseSettings";
import MetabaseReports from "../../Pages/Reseller/MetaBaseReports";
import MetabaseReportsEdit from "../../Pages/Reseller/MetaBaseReports/editReport";
import ViewMetabaseReport from "../../Pages/Reseller/MetaBaseReports/viewReport";

import AdminReports from "../../Pages/Reseller/MetaBaseReports/adminReports";
import AddAdminReports from "../../Pages/Reseller/MetaBaseReports/addAdminReports";
import EditAdminReports from "../../Pages/Reseller/MetaBaseReports/editAdminReports";
import ViewAdminReport from "../../Pages/Reseller/MetaBaseReports/viewAdminReport";
import AddClientReport from "../../Pages/Reseller/MetaBaseReports/addClientReport";
import ReportGroups from "../../Pages/Reseller/MetaBaseReports/reportGroups";

import AgentReports from "../../Pages/Reseller/MetaBaseReports/agentReports";
import AddAgentReport from "../../Pages/Reseller/MetaBaseReports/addAgentReport";
import EditAgentReport from "../../Pages/Reseller/MetaBaseReports/editAgentReport";
import ViewAgentReport from "../../Pages/Reseller/MetaBaseReports/viewAgentReport";

import Compliance from "../../Pages/Reseller/Compliance";
import AddSubpoenaReport from "../../Pages/Reseller/Compliance/addSubpoenaReport";
import EditSubpoenaReport from "../../Pages/Reseller/Compliance/editSubpoenaReport";
import ViewSubpoenaReport from "../../Pages/Reseller/Compliance/viewSubpoenaReport";

import RfqQuestionsGroups from "../../Pages/Reseller/QuestionsLibrary/groups";
import RfqQuestionsAddGroup from "../../Pages/Reseller/QuestionsLibrary/addGroup";
import RfqQuestionsEditGroup from "../../Pages/Reseller/QuestionsLibrary/editGroup";

import QuestionsLibrary from "../../Pages/Reseller/QuestionsLibrary";
import AddQuestionsLibrary from "../../Pages/Reseller/QuestionsLibrary/addquestions";
import EditQuestionsLibrary from "../../Pages/Reseller/QuestionsLibrary/editquestions";

import Quotations from "../../Pages/Reseller/Quotations";
import Rfqs from "../../Pages/Reseller/Quotations/Rfqs";
import EditQuotations from "../../Pages/Reseller/Quotations/edit";

import QuotationAgreements from "../../Pages/Reseller/Quotations/agreements";
import AddQuotationAgreements from "../../Pages/Reseller/Quotations/addagreement";
import EditQuotationAgreements from "../../Pages/Reseller/Quotations/editagreement";

import SalesOrders from "../../Pages/Reseller/SalesOrders";
import ViewSalesOrder from "../../Pages/Reseller/SalesOrders/view";
import EditSalesOrder from "../../Pages/Reseller/SalesOrders/edit";
import Invoices from "../../Pages/Reseller/Invoices";

import PurchaseOrders from "../../Pages/Reseller/PurchaseOrders";

import Vendors from "../../Pages/Reseller/Vendors";

import ClientPermissons from "../../Pages/Reseller/ClientPermissons";

import Collaterals from "../../Pages/Reseller/Collaterals";
import CollateralsGroups from "../../Pages/Reseller/Collaterals/group";
import CollateralsAddGroup from "../../Pages/Reseller/Collaterals/addGroup";
import CollateralsEditGroup from "../../Pages/Reseller/Collaterals/editGroup";
import DashboardLoader from "../ContentLoaders/dashboard_loader";
import ErrorPage from "../Errors/404";

import AgentRoles from "../../Pages/Reseller/AgentRoles";
import EditAgentRole from "../../Pages/Reseller/AgentRoles/editAgentRole";
import AddAgentRole from "../../Pages/Reseller/AgentRoles/AddAgentRole";
import EditAgentSubRole from "../../Pages/Reseller/AgentRoles/editAgentSubRole";
import AddAgentSubRole from "../../Pages/Reseller/AgentRoles/AddAgentSubRole";

import Support from "../../Pages/Reseller/Support";
import KnowledgeBase from "../../Pages/Reseller/KnowledgeBase";

import Cms from "../../Pages/Reseller/Cms";
import Pageslist from "../../Pages/Reseller/Cms/pageslist";
import Addpages from "../../Pages/Reseller/Cms/addpages";
import Editpage from "../../Pages/Reseller/Cms/editpage";
import Menuslist from "../../Pages/Reseller/Cms/menuslist";
import Addmenus from "../../Pages/Reseller/Cms/addmenus";
import Editmenu from "../../Pages/Reseller/Cms/editmenu";
import Addheader from "../../Pages/Reseller/Cms/addheader";
import Headerlist from "../../Pages/Reseller/Cms/headerlist";
import Websettings from "../../Pages/Reseller/Cms/websettings";

import Themes from "../../Pages/Reseller/Themes";
import Editor from "../../Pages/Reseller/Themes/editor";

import Forms from "../../Pages/Reseller/Forms";
import AddForm from "../../Pages/Reseller/Forms/addForm";
import EditForm from "../../Pages/Reseller/Forms/editForm";
import ViewForm from "../../Pages/Reseller/Forms/viewForm";
import ViewSubmission from "../../Pages/Reseller/Forms/view_submission";
import ViewClientSubmission from "../../Pages/Reseller/Forms/view_client_submission";
import ViewClientArchivedSubmission from "../../Pages/Reseller/Forms/view_client_archived_submission";
import ViewAgentSubmission from "../../Pages/Reseller/Forms/view_agent_submission";
import ViewSupplierSubmission from "../../Pages/Reseller/Forms/view_supplier_submission";
import EditFormResponse from "../../Pages/Reseller/Forms/editFormResponse";

import SignedAgentAgreements from "../../Pages/Reseller/SignedAgreements/agentAgreements";
import SignedSupplierAgreements from "../../Pages/Reseller/SignedAgreements/supplierAgreements";
import SignedClientAgreements from "../../Pages/Reseller/SignedAgreements/clientAgreements";
import CreditApp from "../../Pages/Reseller/SignedAgreements/creditApp";

import Domains from "../../Pages/Reseller/Domains";
import Adddomains from "../../Pages/Reseller/Domains/adddomains";

import ApiKey from "../../Pages/Reseller/ApiKey";
import ViewAdminAnalytics from "../../Pages/Reseller/MetaBaseReports/viewAdminAnalytics";

// Sales CRM / Leads module
import AdminLeads from "../../Pages/Reseller/SalesCRM";
import LeadsKanban from "../../Pages/Reseller/SalesCRM/LeadsKanban";
import LeadsFunnel from "../../Pages/Reseller/SalesCRM/LeadsFunnel";
import LeadsSettings from "../../Pages/Reseller/SalesCRM/LeadsSettings";
import LeadDetail from "../../Pages/Reseller/SalesCRM/LeadDetail";
import LeadEdit from "../../Pages/Reseller/SalesCRM/LeadEdit";
import ActivitiesFeed from "../../Pages/Reseller/SalesCRM/ActivitiesFeed";
import ArchivedLeads from "../../Pages/Reseller/SalesCRM/ArchivedLeads";

import {
  getAccountData,
  profileUpdate,
  resellerLeftMenu,
} from "../../config/api_calls";
import { getCustomSettings } from "./../../config/reseller_api_calls";
import {
  LOGO,
  THEME_COLOR,
  THEME_TEXT_COLOR,
  VENDOR_SIGNATURE,
} from "../../config/config";
import { REPLACECONTENT, ValidateEmail, normalize } from "../../config/utility";
import HelperClass from "./../../config/helperClass";
import Agreement from "./agreement";

import PasswordStrengthBar from "react-password-strength-bar";
import MutextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import ChatWidget from "./../../components/common/ChatWidget";

const auth = new HelperClass();

class Main extends Component {
  constructor(props) {
    super(props);
    this.countryOptions = countryList().getData().sort((a, b) => {
      if (a.label === "United States") return -1;  // US always first
      if (b.label === "United States") return 1;
      return a.label.localeCompare(b.label);
    });

    if (auth.isLogin() === false) {
      auth.logout();
    }

    this.state = {
      view: this.props.view,
      activePage: "",
      is_msa_signed: false,
      Agreement_Content: "",
      title_agreement: "",
      bgColor: "#f5f6fa",
      vendor_signor_signature_file: "",
      published_date: "",
      defaultLoader: true,
      errorCompName: "",
      comp_name: "",
      errorName: "",
      name: "",
      errorTitle: "",
      title: "",
      errorEmail: "",
      email: "",
      errorPhone: "",
      phone: "",
      errorPass: "",
      password: "",
      confirm_password: "",
      errorAddress: "",
      address: "",
      errorCity: "",
      city: "",
      errorState: "",
      states: "",
      errorZip: "",
      zip: "",
      errorCountry: "",
      country: "",
      errorMessage: "",
      disabled: "",
      successMessage: "",
      routingUrl: "",
      leftMenuArr: [],
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
      isLoading: true,
      loginDetails: [],
      passwordShown: false,
      confirmPasswordShown: false,
      address_autocomplete: true,
      address_validation: true,
      userPermissionsArr: [],
    };
  }

  async componentDidMount() {
    this.setState({ isLoading: true });

    const phoneNumber = await auth.getPhone();
    if (auth.isLogin() === false) {
      auth.logout();
    } else {
      this.setState({
        comp_name: auth.getCompName(),
        name: auth.getName(),
        email: auth.getEmail(),
        phone: phoneNumber,
        title: auth.getTitle(),
      });
      // TEMP-REPRO: delay page render so permissions always land first. REVERT ME.
      setTimeout(() => this.defaultChecks(), 3000);
      await this.getLeftMenu();
    }
    this.setState({ isLoading: false });
    this.getCustomSettings();
  }

  getLeftMenu = async () => {
    let user_type = auth.getUserType();
    let acctno = auth.getAccount();

    if (user_type === "Sub") {
      acctno = auth.getSubUserAccount();
    }
    let res = await resellerLeftMenu(acctno, auth.getToken(), auth.getEmail());
    //console.log("getLeftMenu: ", res.data);
    if (
      res.data.status === 200 &&
      res.data.message === "success" &&
      res.data.data.length > 0
    ) {
      this.props.setLeftMenu(res.data.data);
      this.props.setUserPermissions(res.data.user_permissions);
      this.setState({
        leftMenuArr: res.data.data,
        loginDetails: res.data.loginDetails,
        userPermissionsArr: res.data.user_permissions,
      });
    }
  };

  loginDetailView = () => {
    this.setState({ successMessage: "", errorMessage: "" });
    window.$("#modalLoginDetail").modal("show");
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          city: city && city !== "" ? city : "",
          //state: state && state !== "" ? state : "",
          states: state && state !== "" ? state : "",
          zip: zipCode && zipCode !== "" ? zipCode : "",
          country: country && country !== "" ? country : "",
          address: streetAddress && streetAddress !== "" ? streetAddress : "",
          address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        // console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      // console.error("Error fetching reverse geocoding data:", error);
    }
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone)
      );
    } catch (error) {
      return false;
    }
  };

  formUpdate = async () => {
    let {
      name,
      email,
      comp_name,
      title,
      phone,
      address,
      city,
      states,
      zip,
      country,
      password,
      confirm_password,
    } = this.state;

    let is_validated = true;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (comp_name === "") {
      this.setState({
        errorCompName: "error",
        errorMessage: "Company Name is required.",
      });
      is_validated = false;
    } else if (name === "") {
      this.setState({
        errorCompName: "",
        errorName: "error",
        errorMessage: "Full Name is required.",
      });
      is_validated = false;
    } else if (title === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorTitle: "error",
        errorMessage: "Title is required.",
      });
      is_validated = false;
    } else if (phone === "") {
      this.setState({
        errorPhone: "error",
        errorMessage: "Phone is required.",
      });
      is_validated = false;
    } else if (normalize(phone) === null) {
      this.setState({
        errorPhone: "error",
        errorMessage: "Invalid phone format.",
      });
      is_validated = false;
    } else if (ValidateEmail(email) === false) {
      this.setState({
        errorEmail: "error",
        errorName: "",
        errorMessage: "Invalid email format.",
      });
      is_validated = false;
    } else if (password !== "") {
      if (password.length < 8) {
        this.setState({
          errorPass: "error",
          errorEmail: "",

          errorPhone: "",
          errorMessage: "Use 8 characters or more for your password",
        });
        is_validated = false;
      } else if (!passwordRegex.test(password)) {
        this.setState({
          errorPass: "error",
          errorEmail: "",
          errorPhone: "",
          errorMessage:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (confirm_password === "") {
        this.setState({
          errorPass: "error",

          errorEmail: "",
          errorPhone: "",
          errorMessage: "Confirm password is required.",
        });
        is_validated = false;
      } else if (confirm_password.length < 8) {
        this.setState({
          errorPass: "error",

          errorEmail: "",

          errorPhone: "",
          errorMessage: "Use 8 characters or more for your confirm password",
        });
        is_validated = false;
      } else if (password.trim() != confirm_password.trim()) {
        this.setState({
          errorPass: "error",

          errorEmail: "",

          errorPhone: "",
          errorMessage: "Password and confirm password does not match.",
        });
        is_validated = false;
      }
    }
    if (is_validated) {
      this.setState({
        errorPass: "",
        errorEmail: "",
        errorMessage: "",
        errorConfirm: "",
        errorPhone: "",
        errorTitle: "",
        disabled: true,
      });

      let apiResponce = await profileUpdate(
        auth.getAccount(),
        auth.getToken(),
        name,
        title,
        comp_name,
        phone,
        address,
        city,
        states,
        zip,
        country,
        password,
        auth.getUserType(),
        auth.getSubUserAccount()
      );
      //console.log(apiResponce);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage = apiResponce.data.errors
          ? String(apiResponce.data.errors).replace(/,/g, "<br />")
          : "Address validation failed";

        this.setState({
          errorMessage: formattedErrorMessage,
          disabled: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "success"
      ) {
        Cookies.set(
          "comp_nme__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["comp_name"],
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "name__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["name"],
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "phone__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["phone"],
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "title__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["title"],
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );

        this.setState({
          successMessage: "Profile updated successfully.",
          disabled: false,
        });

        setTimeout(async function () {
          window.$("#modalFormProfile").modal("hide");
        }, 2000);
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorMessage: "Something went wrong,try later.",
          disabled: false,
        });
        return false;
      } else {
        auth.logout();
      }
    }
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  handleChange = (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "comp_name") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }
    this.setState({
      [name]: value,
    });
  };

  handleChangeCountry = (country) => {
    this.setState({
      country: country?.label || "",
    });
  };

  agreementSigned = () => {
    this.setState({ is_msa_signed: true });
  };

  defaultChecks = async () => {
    let apiData = await getAccountData(
      auth.getAccount(),
      auth.getToken(),
      auth.getSubUserAccount(),
      auth.getUserType()
    );
    //console.log("NDA DATA: ", apiData.data);
    if (
      apiData.data.status === 403 ||
      apiData.data.errors === "authentication missing" ||
      apiData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (apiData.data.status === 404 || apiData.data.data.length === 0) {
      //this.props.history.push("/error");
    } else if (apiData.data.status === 200 && apiData.data.data.length > 0) {
      //this.props.addSettings(apiData.data.data[0]["settings"]);
      this.props.addMsaInfo(apiData.data.data[0]["is_msa_signed"]);

      this.setState({
        address: apiData.data.data[0]["address"],
        city: apiData.data.data[0]["city"],
        states: apiData.data.data[0]["state"],
        zip: apiData.data.data[0]["zip"],
        country: apiData.data.data[0]["country"],
        routingUrl: apiData.data.data[0]["url"],
      });
      if (apiData.data.data[0]["is_msa_signed"] === "No") {
        let objReplace = {
          resellerCompName: auth.getCompName(),
          reseller_name: apiData.data.data[0]["name"],
          reseller_comp_name: apiData.data.data[0]["comp_name"],
          reseller_email: apiData.data.data[0]["email"],
          reseller_address: apiData.data.data[0]["address"]
            ? apiData.data.data[0]["address"]
            : "N/A",
          reseller_city: apiData.data.data[0]["city"]
            ? apiData.data.data[0]["city"]
            : "N/A",
          reseller_state: apiData.data.data[0]["state"]
            ? apiData.data.data[0]["state"]
            : "N/A",
          reseller_zip: apiData.data.data[0]["zip"]
            ? apiData.data.data[0]["zip"]
            : "N/A",
          reseller_phone_no: apiData.data.data[0]["phone"],
          vendor_signor_name: apiData.data.agreement[0].vendor_signor_name,
          vendor_signor_comp_name:
            apiData.data.agreement[0].vendor_signor_comp_name,
          vendor_signor_title: apiData.data.agreement[0].vendor_signor_title,
          vendor_signor_address:
            apiData.data.agreement[0].vendor_signor_address,
          vendor_signor_email: apiData.data.agreement[0].vendor_signor_email,
          vendor_signor_phone_no:
            apiData.data.agreement[0].vendor_signor_phone_no,
          vendor_signor_fax: apiData.data.agreement[0].vendor_signor_fax,
          vendor_signor_city: apiData.data.agreement[0].vendor_signor_city,
          vendor_signor_state: apiData.data.agreement[0].vendor_signor_state,
          vendor_signor_zip: apiData.data.agreement[0].vendor_signor_zip,
          vendor_signor_comp_title:
            apiData.data.agreement[0].vendor_signor_comp_title,
          def_did_charges:
            apiData.data.rates[0].did.length > 0 &&
            apiData.data.rates[0].did[0].mrc
              ? apiData.data.rates[0].did[0].mrc
              : "--",
          def_tfn_charges:
            apiData.data.rates[0].tfn.length > 0 &&
            apiData.data.rates[0].tfn[0].mrc
              ? apiData.data.rates[0].tfn[0].mrc
              : "--",
          def_sms_charges:
            apiData.data.rates[0].sms.length > 0 &&
            apiData.data.rates[0].sms[0].mrc
              ? apiData.data.rates[0].sms[0].mrc
              : "--",
          def_term_charges:
            apiData.data.rates[0].term.length > 0 &&
            apiData.data.rates[0].term[0].mrc
              ? apiData.data.rates[0].term[0].mrc
              : "--",
          def_live_agent_charges:
            apiData.data.rates[0].live_agent.length > 0 &&
            apiData.data.rates[0].live_agent[0].mrc
              ? apiData.data.rates[0].live_agent[0].mrc
              : "--",
          def_ivr_charges:
            apiData.data.rates[0].ivr.length > 0 &&
            apiData.data.rates[0].ivr[0].mrc
              ? apiData.data.rates[0].ivr[0].mrc
              : "--",
          def_did_rates:
            apiData.data.rates[0].did.length > 0 &&
            apiData.data.rates[0].did[0].rate
              ? apiData.data.rates[0].did[0].rate
              : "--",
          def_tfn_rates:
            apiData.data.rates[0].tfn.length > 0 &&
            apiData.data.rates[0].tfn[0].rate
              ? apiData.data.rates[0].tfn[0].rate
              : "--",
          def_sms_rates:
            apiData.data.rates[0].sms.length > 0 &&
            apiData.data.rates[0].sms[0].rate
              ? apiData.data.rates[0].sms[0].rate
              : "--",
          def_term_rates:
            apiData.data.rates[0].term.length > 0 &&
            apiData.data.rates[0].term[0].rate
              ? apiData.data.rates[0].term[0].rate
              : "--",
          def_la_rates:
            apiData.data.rates[0].live_agent.length > 0 &&
            apiData.data.rates[0].live_agent[0].rate
              ? apiData.data.rates[0].live_agent[0].rate
              : "--",
          def_ivr_rates:
            apiData.data.rates[0].ivr.length > 0 &&
            apiData.data.rates[0].ivr[0].rate
              ? apiData.data.rates[0].ivr[0].rate
              : "--",
          def_did_nrc:
            apiData.data.rates[0].did.length > 0 &&
            apiData.data.rates[0].did[0].nrc
              ? apiData.data.rates[0].did[0].nrc
              : "--",
          def_tfn_nrc:
            apiData.data.rates[0].tfn.length > 0 &&
            apiData.data.rates[0].tfn[0].nrc
              ? apiData.data.rates[0].tfn[0].nrc
              : "--",
        };

        let newContent = REPLACECONTENT(
          apiData.data.agreement[0]["agreement_content"],
          objReplace,
          ""
        );

        newContent = newContent.replace(
          "VENDOR SIGNATURE DATE SHOWN HERE",
          apiData.data.agreement[0]["published_date"]
        );

        this.setState({
          is_msa_signed: false,
          Agreement_Content: newContent.replace(
            /\[\[IMG_VENDOR_SIGN\]\]/g,
            VENDOR_SIGNATURE
          ),
          title_agreement: apiData.data.agreement[0]["agreement_title"],
          bgColor: "white",
          vendor_signor_signature_file:
            apiData.data.agreement[0]["vendor_signor_signature_file"],
          published_date: apiData.data.agreement[0]["published_date"],
          defaultLoader: false,
        });
      } else if (apiData.data.data[0]["is_msa_signed"] === "Yes") {
        this.setState({
          is_msa_signed: true,
          defaultLoader: false,
        });
      }
    } else if (
      (apiData.data.status === 200 &&
        apiData.data.data[0]["isVerified"] === "No") ||
      apiData.data.data[0]["account_status"] !== "active"
    ) {
      auth.logout();
    } else {
      //this.props.history.push("/error");
    }
  };

  pageView = () => {
    //console.log("PAGE PROP " + this.state.view);
    if (this.state.view === "dashboard") {
      return <Dashboard props={this.props} />;
    } else if (this.state.view === "clients") {
      return <Clients props={this.props} />;
    } else if (this.state.view === "LoadCredit") {
      return <LoadCredit props={this.props} />;
    } else if (this.state.view === "subclients") {
      return <Subclients props={this.props} />;
    } else if (this.state.view === "subclientrights") {
      return <Subclientrights props={this.props} />;
    } else if (this.state.view === "sub_users") {
      return <SubUsers props={this.props} />;
    } else if (this.state.view === "user_roles") {
      return <UserRoles props={this.props} />;
    } else if (this.state.view === "admin_roles") {
      return <AdminRoles props={this.props} />;
    } else if (this.state.view === "edit_role") {
      return <EditAdminRole props={this.props} />;
    } else if (this.state.view === "edit_sub_role") {
      return <EditAdminSubRole props={this.props} />;
    } else if (this.state.view === "SubUserRoleAddGroup") {
      return <AddSubUserGroup props={this.props} />;
    } else if (this.state.view === "SubUserRoleEditGroup") {
      return <EditSubUserGroup props={this.props} />;
    } else if (this.state.view === "client_roles") {
      return <ClientRoles props={this.props} />;
    } else if (this.state.view === "add_client_role") {
      return <AddClientRole props={this.props} />;
    } else if (this.state.view === "add_client_subrole") {
      return <AddClientSubRole props={this.props} />;
    } else if (this.state.view === "edit_client_role") {
      return <EditClientRole props={this.props} />;
    } else if (this.state.view === "edit_client_subrole") {
      return <EditClientSubRole props={this.props} />;
    } else if (this.state.view === "ClientRoleAddGroup") {
      return <ClientRoleAddGroup props={this.props} />;
    } else if (this.state.view === "ClientRoleEditGroup") {
      return <ClientRoleEditGroup props={this.props} />;
    } else if (this.state.view === "Addsubclient") {
      return <Addsubclient props={this.props} />;
    } else if (this.state.view === "adduser") {
      return <AddUsers props={this.props} />;
    } else if (this.state.view === "Clientagreements") {
      return <Clientagreements props={this.props} />;
    } else if (this.state.view === "viewClient") {
      return <ViewClient props={this.props} />;
    } else if (this.state.view === "AddClientagreements") {
      return <AddClientagreements props={this.props} />;
    } else if (this.state.view === "AddClientagreement") {
      return <AddClientagreement props={this.props} />;
    } else if (this.state.view === "EditClientagreements") {
      return <EditClientagreements props={this.props} />;
    } else if (this.state.view === "services") {
      return <Services props={this.props} />;
    } else if (this.state.view === "ServiceType") {
      return <ServiceType props={this.props} />;
    } else if (this.state.view === "EditServiceType") {
      return <EditServiceType props={this.props} />;
    } else if (this.state.view === "AddServiceType") {
      return <AddServiceType props={this.props} />;
    } else if (this.state.view === "support") {
      return <Support props={this.props} />;
    } else if (this.state.view === "knowledgeBase") {
      return <KnowledgeBase props={this.props} />;
    } else if (this.state.view === "cms") {
      return <Cms props={this.props} />;
    } else if (this.state.view === "Pageslist") {
      return <Pageslist props={this.props} />;
    } else if (this.state.view === "Addpages") {
      return <Addpages props={this.props} />;
    } else if (this.state.view === "Editpage") {
      return <Editpage props={this.props} />;
    } else if (this.state.view === "Pdfdownload") {
      return <Pdfdownload props={this.props} />;
    } else if (this.state.view === "Editmenu") {
      return <Editmenu props={this.props} />;
    } else if (this.state.view === "Menuslist") {
      return <Menuslist props={this.props} />;
    } else if (this.state.view === "Addmenus") {
      return <Addmenus props={this.props} />;
    } else if (this.state.view === "Addheader") {
      return <Addheader props={this.props} />;
    } else if (this.state.view === "Headerlist") {
      return <Headerlist props={this.props} />;
    } else if (this.state.view === "Websettings") {
      return <Websettings props={this.props} />;
    } else if (this.state.view === "Addservice") {
      return <Addservice props={this.props} />;
    } else if (this.state.view === "Editservice") {
      return <Editservice props={this.props} />;
    } else if (this.state.view === "Addclient") {
      return <Addclient props={this.props} />;
    } else if (this.state.view === "Addratedeck") {
      return <Addratedeck props={this.props} />;
    } else if (this.state.view === "Addbundle") {
      return <Addbundle props={this.props} />;
    } else if (this.state.view === "Adddomains") {
      return <Adddomains props={this.props} />;
    } else if (this.state.view === "analytics") {
      return <Analytics props={this.props} />;
    } else if (this.state.view === "reports") {
      return <Reports props={this.props} />;
    } else if (this.state.view === "agreements") {
      return <Agreements props={this.props} />;
    } else if (this.state.view === "package_agreements") {
      return <PackageAgreements props={this.props} />;
    } else if (this.state.view === "add_package_agreement") {
      return <AddPackageAgreements props={this.props} />;
    } else if (this.state.view === "edit_package_agreement") {
      return <EditPackageAgreements props={this.props} />;
    } else if (this.state.view === "themes") {
      return <Themes props={this.props} />;
    } else if (this.state.view === "domains") {
      return <Domains props={this.props} />;
    } else if (this.state.view === "Editor") {
      return <Editor props={this.props} />;
    } else if (this.state.view === "agents") {
      return <Agents props={this.props} />;
    } else if (this.state.view === "Addagent") {
      return <Addagent props={this.props} />;
    } else if (this.state.view === "AgentCommissions") {
      return <AgentCommissions props={this.props} />;
    } else if (this.state.view === "viewAgent") {
      return <ViewAgent props={this.props} />;
    } else if (this.state.view === "Addsubagent") {
      return <Addsubagent props={this.props} />;
    } else if (this.state.view === "Agentagreements") {
      return <Agentagreements props={this.props} />;
    } else if (this.state.view === "AddAgentagreements") {
      return <AddAgentagreements props={this.props} />;
    } else if (this.state.view === "EditAgentagreements") {
      return <EditAgentagreements props={this.props} />;
    } else if (this.state.view === "Supplieragreements") {
      return <Supplieragreements props={this.props} />;
    } else if (this.state.view === "AddSupplieragreements") {
      return <AddSupplieragreements props={this.props} />;
    } else if (this.state.view === "EditSupplieragreements") {
      return <EditSupplieragreements props={this.props} />;
    } else if (this.state.view === "upgrades") {
      return <Upgrades props={this.props} />;
    } else if (this.state.view === "apiDetails") {
      return <ApiDetails props={this.props} />;
    } else if (this.state.view === "Compliance") {
      return <Compliance props={this.props} />;
    } else if (this.state.view === "metaBaseSettings") {
      return <MetaBaseSettings props={this.props} />;
    } else if (this.state.view === "metabaseReports") {
      return <MetabaseReports props={this.props} />;
    } else if (this.state.view === "metabaseReportsEdit") {
      return <MetabaseReportsEdit props={this.props} />;
    } else if (this.state.view === "addClientReport") {
      return <AddClientReport props={this.props} />;
    } else if (this.state.view === "viewMetabaseReport") {
      return <ViewMetabaseReport props={this.props} />;
    } else if (this.state.view === "agentReports") {
      return <AgentReports props={this.props} />;
    } else if (this.state.view === "addAgentReport") {
      return <AddAgentReport props={this.props} />;
    } else if (this.state.view === "editAgentReport") {
      return <EditAgentReport props={this.props} />;
    } else if (this.state.view === "viewAgentReport") {
      return <ViewAgentReport props={this.props} />;
    } else if (this.state.view === "adminReports") {
      return <AdminReports props={this.props} />;
    } else if (this.state.view === "addAdminReports") {
      return <AddAdminReports props={this.props} />;
    } else if (this.state.view === "editAdminReports") {
      return <EditAdminReports props={this.props} />;
    } else if (this.state.view === "reportGroups") {
      return <ReportGroups props={this.props} />;
    } else if (this.state.view === "viewAdminReport") {
      return <ViewAdminReport props={this.props} />;
    } else if (this.state.view === "addSubpoenaReport") {
      return <AddSubpoenaReport props={this.props} />;
    } else if (this.state.view === "editSubpoenaReport") {
      return <EditSubpoenaReport props={this.props} />;
    } else if (this.state.view === "viewSubpoenaReport") {
      return <ViewSubpoenaReport props={this.props} />;
    } else if (this.state.view === "AgentPermissons") {
      return <AgentPermissons props={this.props} />;
    } else if (this.state.view === "ClientPermissons") {
      return <ClientPermissons props={this.props} />;
    } else if (this.state.view === "Integrations") {
      return <Integrations props={this.props} />;
    } else if (this.state.view === "RfqQuestionsGroups") {
      return <RfqQuestionsGroups props={this.props} />;
    } else if (this.state.view === "RfqQuestionsAddGroup") {
      return <RfqQuestionsAddGroup props={this.props} />;
    } else if (this.state.view === "RfqQuestionsEditGroup") {
      return <RfqQuestionsEditGroup props={this.props} />;
    } else if (this.state.view === "QuestionsLibrary") {
      return <QuestionsLibrary props={this.props} />;
    } else if (this.state.view === "AddQuestionsLibrary") {
      return <AddQuestionsLibrary props={this.props} />;
    } else if (this.state.view === "EditQuestionsLibrary") {
      return <EditQuestionsLibrary props={this.props} />;
    } else if (this.state.view === "subagents") {
      return <Subagents props={this.props} />;
    } else if (this.state.view === "partner_subagents") {
      return <PartnerSubagents props={this.props} />;
    } else if (this.state.view === "Addpartnersubagent") {
      return <Addpartnersubagent props={this.props} />;
    } else if (this.state.view === "view_agent_archived_submission") {
      return <ViewAgentArchivedSubmission props={this.props} />;
    } else if (this.state.view === "view_supplier_archived_submission") {
      return <ViewSupplierArchivedSubmission props={this.props} />;
    } else if (this.state.view === "notifications") {
      return <Notifications props={this.props} />;
    } else if (this.state.view === "Collaterals") {
      return <Collaterals props={this.props} />;
    } else if (this.state.view === "CollateralsGroups") {
      return <CollateralsGroups props={this.props} />;
    } else if (this.state.view === "CollateralsAddGroup") {
      return <CollateralsAddGroup props={this.props} />;
    } else if (this.state.view === "CollateralsEditGroup") {
      return <CollateralsEditGroup props={this.props} />;
    } else if (this.state.view === "CannedEmails") {
      return <CannedEmails props={this.props} />;
    } else if (this.state.view === "Editemail") {
      return <Editemail props={this.props} />;
    } else if (this.state.view === "EditAgentemail") {
      return <EditAgentemail props={this.props} />;
    } else if (this.state.view === "PreviewEmail") {
      return <PreViewEmail props={this.props} />;
    } else if (this.state.view === "PreviewAgentEmail") {
      return <PreviewAgentEmail props={this.props} />;
    } else if (this.state.view === "Rfqs") {
      return <Rfqs props={this.props} />;
    } else if (this.state.view === "Quotations") {
      return <Quotations props={this.props} />;
    } else if (this.state.view === "EditQuotations") {
      return <EditQuotations props={this.props} />;
    } else if (this.state.view === "QuotationAgreements") {
      return <QuotationAgreements props={this.props} />;
    } else if (this.state.view === "AddQuotationAgreements") {
      return <AddQuotationAgreements props={this.props} />;
    } else if (this.state.view === "EditQuotationAgreements") {
      return <EditQuotationAgreements props={this.props} />;
    } else if (this.state.view === "Invoices") {
      return <Invoices props={this.props} />;
    } else if (this.state.view === "SalesOrders") {
      return <SalesOrders props={this.props} />;
    } else if (this.state.view === "ViewSalesOrder") {
      return <ViewSalesOrder props={this.props} />;
    } else if (this.state.view === "EditSalesOrder") {
      return <EditSalesOrder props={this.props} />;
    } else if (this.state.view === "PurchaseOrders") {
      return <PurchaseOrders props={this.props} />;
    } else if (this.state.view === "Vendors") {
      return <Vendors props={this.props} />;
    } else if (this.state.view === "SignedAgentAgreements") {
      return <SignedAgentAgreements props={this.props} />;
    } else if (this.state.view === "SignedSupplierAgreements") {
      return <SignedSupplierAgreements props={this.props} />;
    } else if (this.state.view === "SignedClientAgreements") {
      return <SignedClientAgreements props={this.props} />;
    } else if (this.state.view === "CreditApp") {
      return <CreditApp props={this.props} />;
    } else if (this.state.view === "Productagreements") {
      return <Productagreements props={this.props} />;
    } else if (this.state.view === "AddProductagreements") {
      return <AddProductagreements props={this.props} />;
    } else if (this.state.view === "EditProductagreements") {
      return <EditProductagreements props={this.props} />;
    } else if (this.state.view === "agent_roles") {
      return <AgentRoles props={this.props} />;
    } else if (this.state.view === "edit_agent_role") {
      return <EditAgentRole props={this.props} />;
    } else if (this.state.view === "add_agent_role") {
      return <AddAgentRole props={this.props} />;
    } else if (this.state.view === "edit_agent_subrole") {
      return <EditAgentSubRole props={this.props} />;
    } else if (this.state.view === "add_agent_subrole") {
      return <AddAgentSubRole props={this.props} />;
    } else if (this.state.view === "back office") {
      return <BackOffice props={this.props} />;
    } else if (this.state.view === "forms") {
      return <Forms props={this.props} />;
    } else if (this.state.view === "add_form") {
      return <AddForm props={this.props} />;
    } else if (this.state.view === "edit_form") {
      return <EditForm props={this.props} />;
    } else if (this.state.view === "view_submission") {
      return <ViewSubmission props={this.props} />;
    } else if (this.state.view === "view_client_submission") {
      return <ViewClientSubmission props={this.props} />;
    } else if (this.state.view === "view_client_archived_submission") {
      return <ViewClientArchivedSubmission props={this.props} />;
    } else if (this.state.view === "view_agent_submission") {
      return <ViewAgentSubmission props={this.props} />;
    } else if (this.state.view === "view_supplier_submission") {
      return <ViewSupplierSubmission props={this.props} />;
    } else if (this.state.view === "view_form") {
      return <ViewForm props={this.props} />;
    } else if (this.state.view === "edit_form_response") {
      return <EditFormResponse props={this.props} />;
    } else if (this.state.view === "viewAdminAnalytics") {
      return <ViewAdminAnalytics props={this.props} />;
    } else if (this.state.view === "ApiKey") {
      return <ApiKey props={this.props} />;
    } else if (this.state.view === "suppliers") {
      return <Suppliers props={this.props} />;
    } else if (this.state.view === "Addsupplier") {
      return <AddSupplier props={this.props} />;
    } else if (this.state.view === "viewSupplier") {
      return <ViewSupplier props={this.props} />;
    } else if (this.state.view === "all_trunks") {
      return <AllTrunks props={this.props} />;
    } else if (this.state.view === "pending_approval") {
      return <PendingApproval props={this.props} />;
    } else if (this.state.view === "add_trunk") {
      return <AddTrunk props={this.props} />;
    // } else if (this.state.view === "batch_management") {
    //   return <BatchManagement props={this.props} />;
    // } else if (this.state.view === "batch_view") {
    //   return <BatchView props={this.props} />;
    // } else if (this.state.view === "number_registry") {
    //   return <NumberRegistry props={this.props} />;
    // } else if (this.state.view === "ani_monitoring") {
    //   return <ANIMonitoring props={this.props} />;
    // } else if (this.state.view === "operations") {
    //   return <OPERATIONS props={this.props} />;
    } else if (
      this.state.view === "crm_leads" ||
      this.state.view === "crm_leads_new" ||
      this.state.view === "crm_leads_won"
    ) {
      return <AdminLeads props={this.props} />;
    } else if (this.state.view === "crm_sales_funnel") {
      return <LeadsFunnel props={this.props} />;
    } else if (this.state.view === "crm_leads_kanban") {
      return <LeadsKanban props={this.props} />;
    } else if (this.state.view === "crm_activities") {
      return <ActivitiesFeed props={this.props} />;
    } else if (this.state.view === "crm_leads_settings") {
      return <LeadsSettings props={this.props} />;
    } else if (this.state.view === "crm_leads_archived") {
      return <ArchivedLeads props={this.props} />;
    } else if (this.state.view === "crm_lead_detail") {
      return <LeadDetail props={this.props} />;
    } else if (this.state.view === "crm_lead_edit") {
      return <LeadEdit props={this.props} />;
    }
    if (this.state.view === "msa_signing") {
      return <MSA />;
    } else {
      return <ErrorPage />;
    }
  };

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  pageChange = (data) => {
    this.props.history.push("/" + data);
  };

  profileView = () => {
    this.setState({ successMessage: "", errorMessage: "", password: "" });
    window.$("#modalFormProfile").modal("show");
  };

  getCustomSettings = async () => {
    try {
      const getCustomSetting_res = await getCustomSettings(
        auth.getAccount(),
        auth.getToken()
      );
      //console.log("getCustomSetting_res: ", getCustomSetting_res.data);
      if (
        getCustomSetting_res.data.status === 200 &&
        getCustomSetting_res.data.data &&
        getCustomSetting_res.data.data.length > 0
      ) {
        this.setState({
          address_autocomplete:
            getCustomSetting_res.data.data[0].address_autocomplete || "Yes",
          address_validation:
            getCustomSetting_res.data.data[0].address_validation || "Yes",
        });
      }
    } catch (error) {
      // console.error("Error fetching settings:", error);
    }
  };

  render() {
    const { useGooglePlaces, toggleButtonText } = this.state;
    const baseMenu = Array.isArray(this.props.leftMenuItems)
      ? this.props.leftMenuItems
      : [];
    return (
      <div className="nk-body bg-lighter npc-general has-sidebar ">
        <div className="nk-app-root">
          <div className="nk-main">
            {auth.isLogin() !== false ? (
              <div>
                <LefeSideBar
                  mainProps={this.props}
                  routingUrl={this.state.routingUrl}
                  menuArr={baseMenu}
                  {...this.props}
                />
              </div>
            ) : null}

            <div className="nk-wrap ">
              <Header
                isNdaSigned={this.state.is_msa_signed}
                modalOpen={() => {
                  this.profileView();
                }}
                modalLogin={() => {
                  this.loginDetailView();
                }}
              />

              {this.state.is_msa_signed === true ? (
                this.pageView()
              ) : (
                <Agreement
                  content={this.state.Agreement_Content}
                  title={this.state.title_agreement}
                  backgroundColor={this.state.bgColor}
                  vendor_signor_signature_file={
                    this.state.vendor_signor_signature_file
                  }
                  published_date={this.state.published_date}
                  mainHistory={this.props}
                  agreementSigned={() => this.agreementSigned()}
                />
              )}
              {/* MODAL EDIT PROFILE START */}
              <div className="modal fade" tabIndex="-1" id="modalFormProfile">
                <div className="modal-dialog modal-xl" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Edit Profile</h5>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* Error Start */}
                      {this.state.errorMessage !== "" ? (
                        <div className="example-alert">
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: this.state.errorMessage,
                                }}
                              ></p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessage !== "" ? (
                        <div className="example-alert">
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <br />

                      <div className="row g-4">
                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              required
                              label="Company Name"
                              error={this.state.errorCompName === "error"}
                              id="comp_name"
                              name="comp_name"
                              value={this.state.comp_name}
                              placeholder="Enter your company name"
                              onChange={this.handleChange}
                              type="text"
                              variant="outlined"
                              fullWidth
                              helperText="Allowed characters: (&nbsp; _ &nbsp; . &nbsp; -
                              &nbsp; , &nbsp; : &nbsp; &amp; &nbsp; ( ) &nbsp; |
                              &nbsp; ! &nbsp; @ )"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              required
                              label="Full Name"
                              error={this.state.errorName === "error"}
                              id="name"
                              name="name"
                              value={this.state.name}
                              placeholder="Enter your name"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                              helperText="Allowed characters: (&nbsp; _ &nbsp; . &nbsp; -
                              &nbsp; , &nbsp; : &nbsp; &amp; &nbsp; ( ) &nbsp; |
                              &nbsp; ! &nbsp; @ )"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              required
                              label="Title"
                              error={this.state.errorTitle === "error"}
                              id="title"
                              name="title"
                              value={this.state.title}
                              placeholder="Enter your title"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                              helperText="Allowed characters: (&nbsp; _ &nbsp; . &nbsp; -
                              &nbsp; , &nbsp; : &nbsp; &amp; &nbsp; ( ) &nbsp; |
                              &nbsp; ! &nbsp; @ )"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 mt-3">
                          <div className="form-group">
                            <MutextField
                              label="Email"
                              type="text"
                              error={this.state.errorEmail === "error"}
                              id="email"
                              name="email"
                              value={this.state.email}
                              placeholder="Enter your email address"
                              onChange={this.handleChange}
                              disabled={true}
                              variant="outlined"
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 mt-3">
                          <ReactPhoneInput
                            country="us"
                            value={(this.state.phone || "").replace(/^\+/, "")}
                            onChange={(value) =>
                              this.handleChange({
                                target: {
                                  name: "phone",
                                  value: value ? `+${value}` : "",
                                },
                              })
                            }
                            inputProps={{
                              name: "phone",
                              id: "phone",
                              required: true,
                              maxLength: 20,
                            }}
                            specialLabel="Phone Number *"
                            containerStyle={{ width: "100%", marginTop: "2px" }}
                            inputStyle={{ width: "100%", height: "56px" }}
                            isValid={!this.state.errorPhone}
                          />
                        </div>

                        <div
                          className="form-group col-lg-4"
                          style={{ marginBottom: "0px" }}
                        >
                          <div className="nk-block-between-md">

                            {this.state.address_autocomplete === "Yes" && (
                              <div className="nk-block-head-content">
                                <ul className="nk-block-tools gx-3">
                                  <li>
                                    <a
                                      onClick={this.handleToggle}
                                      className="text-primary fs-11"
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "11px",
                                      }}
                                    >
                                      {this.state.toggleButtonText}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </div>

                          {/* Address Field Logic */}
                          {this.state.address_autocomplete === "Yes" ? (
                            this.state.useGooglePlaces ? (
                              <GooglePlacesAutocomplete
                                apiKey={
                                  process.env
                                    .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                }
                                apiOptions={{ loading: 'async' }}
                                selectProps={{
                                  value: this.state.address
                                    ? {
                                        label: this.state.address,
                                        value: this.state.address,
                                      }
                                    : null,
                                  onChange: this.handleAddressSelect,
                                  placeholder: this.state.address
                                    ? null
                                    : "Enter your address *",
                                  styles: {
                                    input: (provided) => ({
                                      ...provided,
                                      color: "black",
                                      height: "43px",
                                    }),
                                    option: (provided) => ({
                                      ...provided,
                                      color: "black",
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      color: "black",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 9,
                                    }),
                                  },
                                }}
                                className="googleLocation-autocomplete"
                              />
                                ) : (
                              <MutextField
                                id="address"
                                name="address"
                                type="text"
                                label="PO Box Address *"
                                value={this.state.address}
                                placeholder="PO Box Address. i.e, PO Box Number, City, State Zip Code"
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                error={this.state.errorAddress === "error"}
                              />
                            )
                          ) : (
                            // address_autocomplete === "No" → show PO Box only
                            <MutextField
                              id="address"
                              name="address"
                              type="text"
                              label="Address"
                              value={this.state.address}
                              placeholder="Enter your address"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                              error={this.state.errorAddress === "error"}
                            />
                          )}
                        </div>

                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              required
                              label="City"
                              type="text"
                              error={this.state.errorCity === "error"}
                              id="city"
                              name="city"
                              value={this.state.city}
                              placeholder="Enter your city"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <div className="form-group">
                            <MutextField
                              required
                              label="State"
                              type="text"
                              error={this.state.errorState === "error"}
                              id="states"
                              name="states"
                              value={this.state.states}
                              placeholder="Enter your state"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <div className="form-group">
                            <MutextField
                              required
                              label="Zip Code"
                              type="text"
                              error={this.state.errorZip === "error"}
                              id="zip"
                              name="zip"
                              value={this.state.zip}
                              placeholder="Enter your zip code"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <Autocomplete
                              options={this.countryOptions}
                              getOptionLabel={(option) => option.label}
                              value={
                                this.state.country
                                  ? this.countryOptions.find(opt => opt.label === this.state.country) || null
                                  : null
                              }
                              onChange={(event, newValue) =>
                                this.handleChangeCountry(newValue || { label: "" })
                              }
                              renderInput={(params) => (
                                <MutextField
                                  {...params}
                                  label="Country *"
                                  variant="outlined"
                                  fullWidth
                                  error={this.state.errorCountry === "error"}
                                />
                              )}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              label="Password *"
                              type={
                                this.state.passwordShown ? "text" : "password"
                              }
                              error={this.state.errorPass === "error"}
                              id="password"
                              name="password"
                              value={this.state.password}
                              placeholder="Enter your password"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                              helperText="Password must be at least 8 characters, with uppercase, lowercase, number & special character."
                            />
                            <a
                              style={{
                                left: "auto",
                                top: "30px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={this.togglePassword}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="password"
                            >
                              {this.state.passwordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                            <div style={{ marginTop: "20px" }}>
                              <PasswordStrengthBar
                                password={this.state.password}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              label="Confirm Password *"
                              type={
                                this.state.confirmPasswordShown
                                  ? "text"
                                  : "password"
                              }
                              error={this.state.errorPass === "error"}
                              id="confirm_password"
                              name="confirm_password"
                              value={this.state.confirm_password}
                              placeholder="Enter confirm password"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                              helperText="Confirm Password must be at least 8 characters, with uppercase, lowercase, number & special character. Confirm Password must match the Password."
                            />
                            <a
                              style={{
                                left: "auto",
                                top: "30px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={() => {
                                this.toggleConfirmPassword();
                              }}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="confirm-password"
                            >
                              {this.state.confirmPasswordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                          </div>
                        </div>
                        <div className="col-lg-4">&nbsp;</div>
                        <div style={{ clear: "both" }}></div>
                        {/* <div className="form-group">
                        <label className="form-label" htmlFor="password">
                          Password
                        </label>
                        <div className="form-control-wrap">
                          <a
                            tabIndex="-1"
                            href="#"
                            className="form-icon form-icon-right passcode-switch"
                            data-target="password"
                          >
                            <em className="passcode-icon icon-show icon ni ni-eye"></em>
                            <em className="passcode-icon icon-hide icon ni ni-eye-off"></em>
                          </a>
                          <input
                            type="password"
                            className={
                              "form-control form-control-lg " +
                              this.state.errorPass
                            }
                            id="password"
                            name="password"
                            value={this.state.password}
                            onChange={this.handleChange}
                            placeholder="Enter your password"
                          />
                        </div>
                      </div> */}
                        <div className="col-lg-12 text-right">
                          <a
                            className="btn btn-lg"
                            onClick={() => {
                              this.formUpdate();
                            }}
                            style={{
                              backgroundColor: THEME_COLOR,
                              color: THEME_TEXT_COLOR,
                              float: "right",
                              cursor: "pointer",
                            }}
                            disabled={this.state.disabled}
                          >
                            Update Profile
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END MODAL EDIT PROFILE */}
              {/* { MODAL LOGIN DETAILS } */}
              <div
                className="modal fade"
                id="modalLoginDetail"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalLoginDetailLabel"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="modalLoginDetailLabel">
                        Login Details
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          border: "none",
                          backgroundColor: "transparent",
                        }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {/* Table to Display Login Details */}
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="thead-light">
                            <tr>
                              <th>IP Address</th>
                              <th>Country</th>
                              <th>State</th>
                              <th>City</th>
                              <th>Timezone</th>
                              <th>Login Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.loginDetails &&
                            this.state.loginDetails.length > 0 ? (
                              this.state.loginDetails.map((detail, index) => (
                                <tr key={index}>
                                  <td>{detail.ip_address}</td>
                                  <td>{detail.country}</td>
                                  <td>{detail.state}</td>
                                  <td>{detail.city}</td>
                                  <td>{detail.time_zone}</td>
                                  <td>
                                    {new Date(detail.login_time)
                                      .toLocaleDateString("en-US", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric",
                                      })
                                      .replace(/(\d+)(?=,)/, "$1th")}
                                    ,{" "}
                                    {new Date(
                                      detail.login_time
                                    ).toLocaleTimeString("en-US")}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  No login details found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* { MODAL LOGIN DETAILS } */}
              <Footer />
              {process.env.REACT_APP_SHOW_CHAT_WIDGET === "true" && (
                <ChatWidget user={auth.getEmail()} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    leftMenuItems: state.leftMenuItems,
    userRoleItems: state.userRoleItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
    addMsaInfo: (payload) => dispatch(addMsaInfo(payload)),
    setLeftMenu: (menuItems) => dispatch(setLeftMenu(menuItems)),
    setUserPermissions: (roleItems) => dispatch(setUserPermissions(roleItems)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Main);
